module.exports = __webpack_public_path__ + "media/images/athletes/4148-d9d10e62e62cfcd54c9e83ea6b9d4763.png";